import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {
  $parent: any

  close() {
    this.$parent.close()
  }
}
